import { render } from "./unuse.vue?vue&type=template&id=08c5b888"
import script from "./unuse.vue?vue&type=script&lang=js"
export * from "./unuse.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server\\Document\\live-class-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__